@if (isShowHideOpen) {
  <div class="overlay" (click)="toggleModal()"></div>
  <div class="show-hide-container">
    <div class="title">
      <span>{{ "SHOW&HIDECOLUMNS" | translate }}</span>
    </div>
    <div class="custom-search">
      <img alt="Magnifier" src="assets/device/magnifier.svg" (click)="toggleSearch()" />
      <input
        type="text"
        id="searchInput"
        placeholder="{{ 'SEARCHBYCOLUMNNAME' | translate }}"
        (keyup)="onKeyUp($event)"
        [(ngModel)]="searchText"
      />
    </div>
    <div class="column-container">
      <div class="column-container-item" *ngFor="let column of filteredColumns">
        <div class="column-name">
          <img alt="Show Hide Item" src="assets/core/show&hide/double-column.svg" />
          <span>{{ column.header | translate }}</span>
        </div>
        <div class="switch" (click)="onColumnChange(column, $event)">
          <input
            type="checkbox"
            [id]="'checkbox-' + column.key"
            [checked]="isSelected(column)"
          />
          <span class="slider round"></span>
        </div>
      </div>
    </div>
  </div>
}
<div class="button-wrapper">
  <div class="button" (click)="toggleModal()">
    <div class="button-text">
      <span>{{ "SHOW&HIDECOLUMNS" | translate }}</span>
    </div>
    <div><img alt="Sort" src="assets/core/table-button/sort.svg" /></div>
  </div>
</div>
